export const formSectionsTranslations = {
    BUSINESS_INFO: 'Información del negocio',
    BUSINESS_FINANCE: 'Finanzas del negocio',
    EMPLOYEES_AND_CONTRACTORS: 'Empleados y contratistas',
    EXPERIENCE_APPLYING: 'Experiencia solicitando préstamo o crédito',
    FINANCIAL_INFO_PRIMARY_CONTACT: 'Información financiera - Contacto principal',
    HOUSEHOLD_INFO_PRIMARY_CONTACT: 'Información del hogar - Contacto principal',
    OWNER_INFO: 'Información del propietario/operador',
    CONTACT: 'Contacto',
    CONTACTS: 'Contactos',
    FINANCING: 'Financiamiento',
    EMPLOYEES: 'Empleados',
    PERSONAL: 'Personal',
    CHALLENGES: 'Desafíos',
    'Business Info': 'Información del negocio',
    'Business Finance': 'Finanzas del negocio',
    'Employees & Contractors': 'Empleados y contratistas',
    'Experience Applying for Loan / Credit': 'Experiencia solicitando préstamo o crédito',
    'Financial Info - Primary Contact': 'Información financiera - Contacto principal',
    'Household Information - Primary Contact': 'Información del hogar - Contacto principal',
    'Owner/Operator Information': 'Información del propietario/operador',
    Contact: 'Contacto',
    Contacts: 'Contactos',
    Finance: 'Finanzas',
    Employees: 'Empleados',
    Personal: 'Personal',
    Challenges: 'Desafíos',
    'Primary Contact': 'Contacto principal',
    PROFIT_LOSS: 'Ganancias y Pérdidas',
    BALANCE_SHEET: 'Hoja de Balance',
    JOBS: 'Empleos'
};
